import { createContext } from 'react'

const shipEngineContext = createContext()

export default shipEngineContext
